import { reactive } from 'vue';

/**
 * Confirmation modale, à la place de `window.confirm` : lisible, stylée, et
 * capable de nommer ce qui va se passer. Une seule modale à la fois, montée
 * une fois pour toutes dans App.vue (`ConfirmHost`).
 *
 *   if (!(await confirmAction({ title: 'Supprimer ?', ... }))) return;
 */
export interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  /** Action destructrice ou irréversible : bouton rouge. */
  danger?: boolean;
}

export const confirmState = reactive<{
  open: boolean;
  options: ConfirmOptions;
  resolve: ((value: boolean) => void) | null;
}>({
  open: false,
  options: { title: '', message: '' },
  resolve: null,
});

export function confirmAction(options: ConfirmOptions): Promise<boolean> {
  // Une modale encore ouverte est tenue pour annulée : sa promesse ne doit
  // jamais rester en suspens.
  confirmState.resolve?.(false);
  return new Promise((resolve) => {
    confirmState.options = options;
    confirmState.resolve = resolve;
    confirmState.open = true;
  });
}

export function settleConfirm(value: boolean): void {
  const resolve = confirmState.resolve;
  confirmState.open = false;
  confirmState.resolve = null;
  resolve?.(value);
}
